var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data)?_c('div',{staticClass:"BilgiKutu"},[_c('h1',[_vm._v(_vm._s(_vm.data.Baslik))]),_vm._v(" "),_c('ul',{staticClass:"BilgiKutuUl"},_vm._l((_vm.data.Detay),function(activity,index){return (activity.Bilgi)?_c('li',[_c('small',{staticClass:"d-block"},[_vm._v(_vm._s(activity.Baslik))]),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(activity.Bilgi)}})]):_vm._e()}),0)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6deeefaa","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pack/Genel/BilgiKutu.vue
// module id = 726
// module chunks = 0